module.exports = __webpack_public_path__ + "img/6_1.80ec7543.jpg";